/**
 * MechaGuard - CryoTower (冰冻塔)
 *
 * 攻击方式：周期性脉冲，对射程内所有敌人造成少量伤害并施加减速。
 * 定位：控场塔，不追求伤害，用来延长敌人在火力网中的停留时间。
 * 满级特性：每第 5 次脉冲额外冻结敌人 1.5 秒。
 */

import { Tower } from '../entities/Tower.js';

export class CryoTower extends Tower {
  static META = {
    id: 'cryo',
    name: '冰冻塔',
    icon: '❄️',
    cost: 120,
    desc: '范围减速，满级可冻结',
    color: '#78dcff',
    stats: {
      baseRange: 124,
      baseDamage: 9,
      fireInterval: 1.0,
      turnSpeed: 5,
      firingFx: 0.2,
      slowFactor: 0.7,       // 速度倍率：0.7 = 降低 30% 速度
      slowDuration: 1.6,
      freezeEvery: 5,       // 满级每 N 次脉冲冻结一次
      freezeDuration: 1.5,
    },
  };

  constructor(col, row) {
    super(col, row);
    this.pulseCount = 0;
  }

  update(dt, game) {
    this.tickTimers(dt);

    // 缓慢转向最近的敌人（纯视觉）
    const nearest = this.findClosest(game.enemies);
    if (nearest) this.aimAt(nearest, dt, this.turnSpeed);

    if (this.cooldown > 0) return;
    this.cooldown = this.fireInterval;

    const inRange = game.enemiesInRange(this.x, this.y, this.range);
    if (inRange.length === 0) return;

    this.firing = this.firingFx;
    this.pulseCount += 1;
    game.sfx('cryo');

    const shouldFreeze = this.level >= 3 && this.pulseCount % this.freezeEvery === 0;

    for (let i = 0; i < inRange.length; i++) {
      const e = inRange[i];

      e.applySlow(this.slowFactor, this.slowDuration);
      if (shouldFreeze) e.applyFreeze(this.freezeDuration);

      const dealt = game.damageEnemy(e, this.damage);
      this.totalDamage += dealt;
    }

    game.effects.addRing(this.x, this.y, this.range, this.color, 0.45);
  }

  drawTurret(ctx, accent) {
    // 菱形脉冲核心
    ctx.fillStyle = 'rgba(10, 24, 42, 0.92)';
    ctx.strokeStyle = accent;
    ctx.lineWidth = 2;

    ctx.beginPath();
    ctx.moveTo(0, -11);
    ctx.lineTo(11, 0);
    ctx.lineTo(0, 11);
    ctx.lineTo(-11, 0);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    // 旋转的冰晶
    ctx.save();
    ctx.rotate(this.age * 1.6);
    ctx.strokeStyle = accent;
    ctx.lineWidth = 1.5;
    for (let i = 0; i < 3; i++) {
      ctx.rotate(Math.PI / 3);
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, -8);
      ctx.stroke();
    }
    ctx.restore();

    // 核心光点
    ctx.shadowColor = accent;
    ctx.shadowBlur = 10;
    ctx.fillStyle = '#e8fbff';
    ctx.beginPath();
    ctx.arc(0, 0, 3, 0, Math.PI * 2);
    ctx.fill();
    ctx.shadowBlur = 0;
  }
}
